import { render } from "./EventMakePayment.vue?vue&type=template&id=b892f544&scoped=true"
import script from "./EventMakePayment.vue?vue&type=script&lang=js"
export * from "./EventMakePayment.vue?vue&type=script&lang=js"

import "./EventMakePayment.vue?vue&type=style&index=0&id=b892f544&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b892f544"]])

export default __exports__